import { createQuery } from "@/api/utils";
import { User } from "./User.model";

export const getUser = createQuery<User, { userId: string }>(
    async ({ params, api }) => {
        return api.get(`/identity/users/${params.userId}`);
    },
);
